export default __webpack_public_path__ + "static/media/CIA-Privacy-Policy.6e3bc629.pdf";